export interface SettledBulkAction<T> {
  succeeded: T[]
  failed: T[]
}

export const settleBulkActions = async <T>(
  items: readonly T[],
  action: (item: T) => Promise<unknown>
): Promise<SettledBulkAction<T>> => {
  const outcomes = await Promise.allSettled(items.map((item) => action(item)))
  const succeeded: T[] = []
  const failed: T[] = []

  outcomes.forEach((outcome, index) => {
    if (outcome.status === "fulfilled") succeeded.push(items[index])
    else failed.push(items[index])
  })

  return { succeeded, failed }
}

export const reconcileSelectedIds = (
  selectedIds: ReadonlySet<string>,
  visibleIds: readonly string[]
) => {
  const visibleIdSet = new Set(visibleIds)
  return new Set([...selectedIds].filter((id) => visibleIdSet.has(id)))
}

export const clampProductsPage = (currentPage: number, pageCount: number) =>
  Math.min(Math.max(currentPage, 1), Math.max(pageCount, 1))
